import { Component, Inject, InjectionToken, OnInit, ViewEncapsulation } from '@angular/core';
import { CalibrationlogoEnum } from 'app/enum/calibrationlogoEnum';
import { ControllerType, HttpClientService } from 'app/services/http-client.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Content, TDocumentDefinitions } from 'pdfmake/interfaces';
import htmlToPdfmake from 'html-to-pdfmake';
import { PDFDocument } from 'pdf-lib';
import * as pdfjsLib from 'pdfjs-dist';
import { table } from 'console';
import QRCode from 'qrcode';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-deneme',
  templateUrl: './deneme.component.html',
  styleUrls: ['./deneme.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DenemeComponent implements OnInit {
  constructor(
    private httpClientService: HttpClientService,
    @Inject('backendUrl') private backendUrl: string
  ) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js';
    this.getByIdLogo(0);
  }

  qrCodeBase64: string;

  async generateQRCode(certificateNo: string): Promise<void> {
    // URL'yi oluşturuyoruz
    const url = `${this.backendUrl}${certificateNo}`;

    try {
      // QR kodunu Base64 formatında oluşturuyoruz
      this.qrCodeBase64 = await QRCode.toDataURL(url);  // Base64 formatında QR kodu al
      console.log(this.qrCodeBase64); // Konsola QR kodunun Base64 çıktısını yazdır
    } catch (err) {
      console.error('QR Kod oluşturulurken hata oluştu:', err);
    }
  }

  evironmentalConditions: any[] = [
    { name: 'Sıcaklık', start: '20C', end: '22C' },
    { name: 'Basınç', start: '14Ph', end: '18Ph' },
  ];

  calibrationMethod: any = {
    description: `<p>Kalibrasyon EURAMET/cg-17' de belirtilen yöntem ve prosedürlere uygun olarak hazırlanan T.32 Basınç Kalibrasyon Talimatı ile yapılmıştır.</p><p><em class="ql-size-small">Calibration was carried out with the T.32 Pressure Calibration Instruction prepared in accordance with the methods and procedures specified in EURAMET/cg-17.</em></p>`
  }

  compliance: string = `<p>Kullanıcı ölçüm belirsizliğini dikkate alarak cihazın uygunluğuna kara vermelidir.</p><p><span class="ql-size-small">The User must decide on the suitability of the device, taking into account measurement uncertainty.</span></p>`
  remaks: string = `<p>Kalibrasyon sonuçları kalibrasyon tarihinden itibaren ve sertifikada belirtilmiş olan şartlar altında geçerlidir. Bu sertifikada verilen sonuçlar, cihazın kalibrasyon tarihindeki durumuna alt olup, cihazın uzun dönem kararlılığı ile ilgili anlam taşımazlar. Gelecek kalibrasyon tarihinin belirlenmesinden kullanıcı sorumludur.</p><p><span class="ql-size-small">Calibration results are valid from the calibration date and under the conditions psecifed in the certifcate. The results gibven in this certificate refer to the condition of the device on the calibration date and are not intended to determine the long-term stalility of the device. They do not have any relevant meaning The user is responsible for determinin the next caliration date.</span></p>`
  measurement: string = `<p>Beyan edilen genişletilmiş ölçüm belirsiziliği, standart belirsizliğin, k=2 olarak alınan genişletme katsayısı ile çarpımı sonucunda bulun değerdir ve %95 oranında güvenilirlik sağlamaktadır. Bu sertifikada beyan edilen sonuçlar cihazın kalibrasyon tarihindeki durumunu kapsar ve uzun dönem stabilitesi hakkında bir yorum içermez.</p><p><br></p><p><span class="ql-size-small">The reported expanded uncertainty of measurement is stated as the standard uncertainty of measurument multiplied by the coverage factor k = 2 which for a normal distibution corresponds to a coverage probalitiy of approximately 95% The results reported in this certificate refer to the condition of the Instrument on the date of calibration and carry no impliaction regarding the long-term stability of this Instruement.</span></p>`
  firstPageDescription = `<p>Bu kalibrasyon sertfikası, Uluslararası Birimler Sisteminde(SI) tanımlnamış birimleri realize eden ulusal ölçüm standardlarına izlenebilrliği belgeler.</p><p><span class="ql-size-small">This Calibration certificate documents thetracebilty to national standards, which realize the unit of measurement according to the Inretnational System of Units (SI)</span></p><p>Bu laboratuvar ISO\IEC 17025:2017 Uluslararası standardına göre akredite edilmiştir. Bu akreditasyon tanımlı kapsam için teknik yeterliliği ve laboratuvar kalite yönetim sisteminin işleyişini ve varlığını göstermektedir.</p><p><span class="ql-size-small">This laboratory is acrcredited in accordance with the recognized International Standard ISO\IEC 17025:2017 This accreditaion demonstrates technical competence for a defined scope and the operation of a laboratory quality management system.</span></p><p>Nac kalibrasyon sertifiakalarının tanınırlığı konusunda Uluslararası Laboratuvar Akreditasyon Birlici (ILAC) ile karşılıklı tanıma anlaşması imzalamıştır.</p><p><span class="ql-size-small">Nac is a signatory to the for Accereditation Multilateral Agreeement (MLA) and to the International Loboratory Accreditation Cooperation(ILAC) Mutual Recognition Arrengement(MRA) for the recognition of calibration certifiacates.</span></p><p>Ölçüm sonuçları, genişletilmiş ölçüm belrisizkleri ve kalibrasyon metodları bu sertifkanın tamamlayıcı kısmı olan takip eden sayfalarda verilmiştir.</p><p><span class="ql-size-small">The measurement, the uncertainties with confidence probality and calibration are given on the following pages which are part of this certificate.</span></p>`
  firstPageFooterDescription = `<p>Bu kalibrasyon sertifikası, TS EN ISO/IEC 17025 standardında belirtilen şartlar doğrultusunda hazırlanmıştır, Bu sertifika ancak bütünlüğü bozulmamak kaydıyla ve laboratuvarın yazılı izni alınarak çoğaltılabilir. Mühürsiz ve imzasız kalibrasyon sertfikaları geçerli değildir.</p><p><span class="ql-size-small">This certificate is issued in accordance with the requirements defined in TS EN ISO/IEC 17025 standard. This certificate may not be repoduced other than in full, except with the prior written approval of the issulng laboratory. Calibration vertificates without seal and signature are not valid.</span></p>`

  pdfSrc: any = '';
  pageCount: number = 2;
  extractedText: string = '';
  tableContent: any[] = [];
  img: string[] = [];


  currentPage = 1;  // İlk sayfa
  totalPages = 0;
  pdfDoc: any = null; // PDF dosyasını tutacak
  onFileSelected2(event: Event): void {
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput.files ? fileInput.files[0] : null;

    if (file) {
      const reader = new FileReader();

      // Dosya okuma işlemi tamamlandığında bu fonksiyon çalışacak
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const typedArray = new Uint8Array(e.target?.result as ArrayBuffer);

        // PDF dosyasını pdf.js ile açıyoruz
        pdfjsLib.getDocument(typedArray).promise.then(pdf => {
          this.pdfDoc = pdf;  // PDF dokümanını tutuyoruz
          this.totalPages = pdf.numPages;  // Toplam sayfa sayısını alıyoruz
          const canvasArray: string[] = [];  // Her sayfa için Base64 görseli tutacak dizi

          // Sayfa render işlemi
          const renderPage = (pageNum: number) => {
            pdf.getPage(pageNum).then(page => {
              const scale = 1.5;  // Sayfa ölçeği
              const viewport = page.getViewport({ scale: scale });

              // Canvas oluşturuyoruz
              const canvas = document.createElement('canvas');
              const context = canvas.getContext('2d')!;
              canvas.height = viewport.height;
              canvas.width = viewport.width;

              // Sayfayı canvas'a render ediyoruz
              page.render({
                canvasContext: context,
                viewport: viewport
              }).promise.then(() => {
                const imgData = canvas.toDataURL('image/png');  // Canvas'ı Base64 formatında alıyoruz
                canvasArray.push(imgData);  // Görseli array'e ekliyoruz

                // Eğer tüm sayfalar render edildiyse, yeni sekmede her sayfa görselini açıyoruz
                if (canvasArray.length === this.totalPages) {
                  this.img = canvasArray;  // Tüm Base64 görsellerini saklıyoruz
                  this.openAllPagesInNewTabs(canvasArray);  // Tüm sayfaları yeni sekmelerde açıyoruz
                }
              });
            });
          };

          // Sayfaları sırayla işliyoruz
          for (let pageNum = 1; pageNum <= this.totalPages; pageNum++) {
            renderPage(pageNum);
          }
        });
      };

      reader.readAsArrayBuffer(file);  // Dosyayı okuyoruz
    }
  }

  // Her bir Base64 görseli yeni bir sekmede açan fonksiyon
  openAllPagesInNewTabs(imgDataArray: string[]) {
    const container = document.getElementById('pdf-container');  // Sayfada görselleri ekleyeceğimiz container

    imgDataArray.forEach(imgData => {
      const imgElement = document.createElement('img');
      imgElement.src = imgData;  // Base64 görseli img etiketi kaynağı olarak ayarlıyoruz
      imgElement.style.width = '100%';  // Görselin genişliğini sayfaya uyacak şekilde ayarlıyoruz
      imgElement.style.marginBottom = '20px';  // Sayfalar arasında boşluk bırakıyoruz
      container?.appendChild(imgElement);  // Görseli container'a ekliyoruz
    });
  }

  async extractTableFromPdf(pdfBytes: Uint8Array): Promise<void> {
    try {
      const loadingTask = pdfjsLib.getDocument({ data: pdfBytes });
      const pdfDoc = await loadingTask.promise;

      let tableData: string[][] = []; // Tabloyu tutacağız

      for (let pageNum = 1; pageNum <= pdfDoc.numPages; pageNum++) {
        const page = await pdfDoc.getPage(pageNum);
        const textContent = await page.getTextContent();

        let rows: { [key: number]: { x: number, text: string }[] } = {}; // Satırları gruplamak için

        textContent.items.forEach((item: any) => {
          if ('str' in item) {
            const y = Math.round(item.transform[5]); // Y koordinatını al (satır)
            const x = item.transform[4]; // X koordinatı (sütun sıralama için)

            if (!rows[y]) rows[y] = [];
            rows[y].push({ x, text: item.str });
          }
        });

        // Satırları sırala ve tablolara ekle
        Object.keys(rows).sort((a, b) => Number(b) - Number(a)).forEach(y => {
          const sortedRow = rows[Number(y)].sort((a, b) => a.x - b.x);
          tableData.push(sortedRow.map(cell => cell.text));
        });
      }
      this.tableContent = tableData;  // `tableContent`'e tabloyu kaydediyoruz
      console.log("Çıkarılan Tablo:", tableData);
    } catch (error) {
      console.error("PDF tablosu işlenirken hata oluştu:", error);
    }
  }

  logo = null;
  getByIdLogo(number: number): string | null {
    const logos = Object.values(CalibrationlogoEnum);
    this.logo = logos[number] || null;
    return this.logo;
  }

  // Resmi Base64 formatına dönüştüren yardımcı fonksiyon
  async convertImageToBase64(url: string): Promise<string | null> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous'; // CORS hatalarını önlemek için
      img.src = url;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) return reject(null);
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };

      img.onerror = (err) => {
        console.error("Resim yüklenemedi!", url, err);
        reject(null);
      };
    });
  }

  ngOnInit() { }

  async generatePDF(headerData: headerBilgileri, calibrationData: CalibrationData, calibrationPage2: CalibrationPage2) {
    // Convert image paths to Base64 asynchronously
    calibrationData.certificatePageNumber = this.pageCount + this.totalPages;
    headerData.firmaLogo = await this.convertImageToBase64(headerData.firmaLogo) || '';
    const akraditasyonLogoPath = this.getByIdLogo(headerData.akraditationFirma);
    const akraditasyonFirma = await this.convertImageToBase64(akraditasyonLogoPath) || '';
    // Document definition

    const documentDefinition = {
      pageSize: 'A4',
      pageMargins: [40, 170, 40, 90],

      // Header for each page
      header: (currentPage, pageCount, pageSize) => {
        return this.getHeaderContent(currentPage, akraditasyonFirma, headerData);
      },
      // Content of the document (multiple pages)
      content: [
        await this.createCalibrationPageContent(calibrationData, true),
        this.createCalibrationPage2(calibrationPage2),
        this.createCalibrationOtherPage(this.img)
      ],
      // Footer for each page
      footer: (currentPage, pageCount) => this.getFooterContent(currentPage, pageCount)
    }

    // Generate and open the PDF
    pdfMake.createPdf(documentDefinition as unknown as TDocumentDefinitions).open();
  }

  async createCalibrationPageContent(calibrationData: CalibrationData, pageBreak: boolean) {
    let firstPageDescriptionToHtml = htmlToPdfmake(this.firstPageDescription);
    firstPageDescriptionToHtml = this.applyDefaultFontSize(firstPageDescriptionToHtml);

    const seal = await this.convertImageToBase64('/assets/logo/muhur.png').catch(err => console.log(err));
    const imza1 = await this.convertImageToBase64('/assets/logo/e-imza.png').catch(err => console.log(err));
    await this.generateQRCode(calibrationData.certificateNo);
    return [
      {
        table: {
          widths: ['30%', '70%'], // İlk sütun başlık, ikinci sütun veri
          body: [
            [{ text: 'Cihaz Sahibi:', bold: true, fontSize: 10 }, { text: `${calibrationData.deviceOwner}`, fontSize: 10 }],
            [{ text: 'Customer', fontSize: 8, margin: [0, 0, 0, 5] }, { text: `${calibrationData.address}`, fontSize: 8 }],

            [{ text: 'Sipariş Numarası:', bold: true, fontSize: 10 }, { text: `${calibrationData.orderNumber}`, fontSize: 10 }],
            [{ text: 'Order No', fontSize: 8, margin: [0, 0, 0, 5] }, {}],

            [{ text: 'Cihaz:', bold: true, fontSize: 10 }, { text: `${calibrationData.deviceName}`, fontSize: 10 }],
            [{ text: 'Device', fontSize: 8, margin: [0, 0, 0, 5] }, {}],

            [{ text: 'Marka:', bold: true, fontSize: 10 }, { text: `${calibrationData.manufacturer}`, fontSize: 10 }],
            [{ text: 'Brand', fontSize: 8, margin: [0, 0, 0, 5] }, {}],

            [{ text: 'Model:', bold: true, fontSize: 10 }, { text: `${calibrationData.modelType}`, fontSize: 10 }],
            [{ text: 'Type', fontSize: 8, margin: [0, 0, 0, 5] }, {}],

            [{ text: 'Seri Numarası:', bold: true, fontSize: 10 }, { text: `${calibrationData.serialNumber}`, fontSize: 10 }],
            [{ text: 'Serial Number', fontSize: 8, margin: [0, 0, 0, 5] }, {}],

            [{ text: 'Kalibrasyon Tarihi:', bold: true, fontSize: 10 }, { text: `${calibrationData.calibrationDate}`, fontSize: 10 }],
            [{ text: 'Date of Calibration', fontSize: 8, margin: [0, 0, 0, 5] }, {}],

            [{ text: 'Sertifika Sayfa Numarası:', bold: true, fontSize: 10 }, { text: `${calibrationData.certificatePageNumber}`, fontSize: 10 }],
            [{ text: 'Number of Pages of The Certificate', fontSize: 8, margin: [0, 0, 0, 5] }, {}],
          ]
        },
        layout: 'noBorders', // Tablo çizgilerini kaldırdım
        margin: [0, 0, 0, 2],
      },
      {
        stack: [firstPageDescriptionToHtml]
      },
      {
        table: {
          widths: ['25%', '25%', '25%', '25%'],
          body: [
            [{ text: "Mühür", bold: true, fontSize: 8, alignment: 'center' }, { text: "Kontrol Kodu", bold: true, fontSize: 8, alignment: 'center' }, { text: "Kalibrasyon Yapan", bold: true, fontSize: 8, alignment: 'center' }, { text: "Onaylayan", bold: true, fontSize: 8, alignment: 'center' }],
            [{ text: "Seal", fontSize: 6, alignment: 'center' }, { text: "Qr Code", fontSize: 6, alignment: 'center' }, { text: "Calibrated by", fontSize: 6, alignment: 'center' }, { text: "Approval", fontSize: 6, alignment: 'center' }],
            [{ image: seal, fit: [75, 75], alignment: 'center' }, { image: this.qrCodeBase64, fit: [75, 75], alignment: 'center' }, [
              { text: calibrationData.kalYapan, fontSize: 10, alignment: 'center', marginBottom: 5 },
              { image: imza1, fit: [75, 75], alignment: 'center' }
            ], [
              { text: calibrationData.onaylayan, fontSize: 10, alignment: 'center', marginBottom: 5 },
              { image: imza1, fit: [75, 75], alignment: 'center' }
            ]]
          ],
        },
        layout: 'noBorders',
        margin: [0, 5, 0, 0],
      },
      pageBreak ? { text: '', pageBreak: 'after' } : { text: '' },
    ];
  }

  applyDefaultFontSize(obj: any) {
    if (Array.isArray(obj)) {
      return obj.map(item => this.applyDefaultFontSize(item));
    } else if (typeof obj === "object" && obj !== null) {
      if (!obj.fontSize) {
        obj.fontSize = 10; // Varsayılan font size ekle
      }
      // Eğer fontSize 10 ve 'ql-size-small' varsa, 8 yapalım
      if (obj.fontSize === 10 && obj.text && obj.style?.includes("ql-size-small")) {
        obj.fontSize = 8; // `ql-size-small` varsa font size'ı 8 yapıyoruz
      }
      // Margin'i küçültme (margin varsa %20 oranında küçültme)
      if (obj.margin) {
        obj.margin = obj.margin.map((m: number) => m * 0.1); // Margin'i %20 oranında küçültme
      }
      // Nesnenin içindeki diğer öğeleri kontrol et
      Object.keys(obj).forEach(key => {
        obj[key] = this.applyDefaultFontSize(obj[key]);
      });
    }
    return obj;
  }

  createCalibrationPage2(calibrationPage2: CalibrationPage2) {
    let cleanedHtml = this.calibrationMethod.description;
    let calibrationText = htmlToPdfmake(cleanedHtml);
    calibrationText = this.applyDefaultFontSize(calibrationText);
    console.log(calibrationText);

    let remaksToHtml = htmlToPdfmake(this.remaks);
    remaksToHtml = this.applyDefaultFontSize(remaksToHtml);

    let complianceToHtml = htmlToPdfmake(this.compliance);
    complianceToHtml = this.applyDefaultFontSize(complianceToHtml);

    let measurementToHtml = htmlToPdfmake(this.measurement);
    measurementToHtml = this.applyDefaultFontSize(measurementToHtml);
    return [
      {
        text: [
          {
            text: "Kalibre Edilen Cihaz /", bold: true, fontSize: 12,
          },
          {
            text: "Device to be calibrate", fontSize: 10,
          },
        ],
        margin: [0, -50, 0, 0]
      },
      {
        columns: [
          {
            table: {
              widths: ['50%', '50%'], // İki sütunlu tablo
              body: [
                // İlk tablo: Cihaz bilgileri
                [{ text: 'Cihaz Adı / Device Name :', bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.deviceName}`, fontSize: 10 }],
                [{ text: 'Seri Numarası / Serial No :', bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.serialNo}`, fontSize: 10 }],
                [{ text: 'Cihaz Numarası / Device No :', bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.deviceNumber}`, fontSize: 10 }],
                [{ text: 'Bulunduğu Yer / Location :', bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.location}`, fontSize: 10 }],
              ]
            },
            layout: 'noBorders', // Tablo çizgilerini kaldırdım
            margin: [0, 5, 0, 0],
          },
          {
            table: {
              widths: ['50%', '50%'], // İkinci tablo: Model ve ölçüm bilgileri
              body: [
                [{ text: 'Marka Tipi / Brand Type :', bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.brand}`, fontSize: 10 }],
                [{ text: 'Model / Model :', bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.type}`, fontSize: 10 }],
                [{ text: 'Ölçüm Aralığı / Range :', bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.range}`, fontSize: 10 }],
                [{ text: 'Çözünürlük / Resolution :', bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.resolution}`, fontSize: 10 }],
              ]
            },
            layout: 'noBorders', // Tablo çizgilerini kaldırdım
            margin: [0, 5, 0, 0],
          },
          // Tabloların altındaki ek bilgiler
        ],
      },
      {
        table: {
          widths: ['50%', '50%'],
          body: [
            [{ text: `Cihazın Laboratuvara Kabul Tarihi:`, bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.incomingDateOfDeviceLaboratory}`, fontSize: 10 }],
            [{ text: `Cihazın Görsel ve Fonksiyonel Kontrolü:`, bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.visualFunctionInspectionDevice}`, fontSize: 10 }]
          ],
        },
        layout: 'noBorders',
        margin: [0, 0, 0, 0],
      },
      {
        stack: [
          {
            columns: [
              {
                text: [
                  { text: "Kalibrasyonda Kullanılan Cihazlar /", bold: true, fontSize: 12 },
                  { text: "References used in calibration", fontSize: 10 },
                ]
              }
            ],
            margin: [0, 10, 0, 0],
          },
          {
            table: {
              widths: ['14.2%', '14.2%', '14.2%', '14.2%', '14.2%', '14.2%', '14.2%'], // 7 sütun için genişlikleri belirledim
              body: [
                [{ text: 'Cihaz Adı', fontSize: 10, bold: true }, { text: 'Marka', fontSize: 10, bold: true }, { text: 'Model', fontSize: 10, bold: true }, { text: 'Seri No', fontSize: 10, bold: true }, { text: 'Sertfika No', fontSize: 10, bold: true }, { text: 'Kal. Tarihi', fontSize: 10, bold: true }, { text: 'İzlenebilirlik', fontSize: 10, bold: true }],
                [{ text: 'Device Name', fontSize: 8, bold: true }, { text: 'Brand', fontSize: 8, bold: true }, { text: 'Model', fontSize: 8, bold: true }, { text: 'Serial No', fontSize: 8, bold: true }, { text: 'Certificate No', fontSize: 8, bold: true }, { text: 'Cal. Date', fontSize: 8, bold: true }, { text: 'Tracebility', fontSize: 8, bold: true }],
                ...calibrationPage2.references.map(ref => [
                  { text: ref.deviceName, fontSize: 9 },
                  { text: ref.brand, fontSize: 9 },
                  { text: ref.model, fontSize: 9 },
                  { text: ref.serialNumber, fontSize: 9 },
                  { text: ref.certificateNumber, fontSize: 9 },
                  { text: ref.calibrationDate, fontSize: 9 },
                  { text: ref.tracebility, fontSize: 9 } // İzlenebilirlik için örnek veri (isteğe bağlı)
                ])
              ],
            },
            layout: 'noBorders',
            margin: [0, 5, 0, 0],
          }

        ]
      },
      {
        stack: [
          {
            columns: [
              {
                text: [
                  { text: "Ortam Şartları /", bold: true, fontSize: 12 },
                  { text: "Environment Conditions", fontSize: 10 },
                ]
              }
            ],
            margin: [0, 10, 0, 0],
          },
          {
            table: {
              widths: ["*", "*", "*"],
              body: [
                [{ text: "Şart / Condition", bold: true, fontSize: 9 }, { text: "Başlangıç / Start", bold: true, fontSize: 9 }, { text: "Bitiş / End", bold: true, fontSize: 9 }],
                ...(this.evironmentalConditions || []).map(ref => [
                  { text: ref.name || "-", fontSize: 8 },
                  { text: ref.start || "-", fontSize: 8 },
                  { text: ref.end || "-", fontSize: 8 },
                ])
              ],
            },
            layout: 'noBorders',
            margin: [0, 5, 0, 0],
          }
        ]
      },
      {
        stack: [
          {
            columns: [
              {
                text: [
                  { text: "Kalibrasyon Metodu /", bold: true, fontSize: 12 },
                  { text: "Calibration Method", fontSize: 10 },
                ]
              },
            ],
            margin: [0, 10, 0, 0],
          },
          {
            stack: [calibrationText],
          }
        ]
      },
      {
        stack: [
          {
            columns: [
              {
                text: [
                  { text: "Açıklama /", bold: true, fontSize: 12 },
                  { text: "Remarks", fontSize: 10 },
                ]
              },
            ],
            margin: [0, 10, 0, 0],
          },
          {
            stack: [remaksToHtml]
          }
        ]
      },
      {
        stack: [
          {
            columns: [
              {
                text: [
                  { text: "Uygunluk Beyanı /", bold: true, fontSize: 12 },
                  { text: "Statement Of Complance", fontSize: 10 },
                ]
              },
            ],
            margin: [0, 10, 0, 0],
          },
          {
            stack: [complianceToHtml]
          }
        ]
      },
      {
        stack: [
          {
            columns: [
              {
                text: [
                  { text: "Ölçüm Belirsizliği /", bold: true, fontSize: 12 },
                  { text: "Measurement Uncertaintily", fontSize: 10 },
                ]
              },
            ],
            margin: [0, 10, 0, 0],
          },
          {
            stack: [measurementToHtml]
          }
        ]
      },
      // Sayfa sonu eklemeleri (isteğe bağlı)
      { text: '', pageBreak: 'after' }, // Eğer sayfa sonu gerekiyorsa, sayfa kesme ekleyebilirsiniz
    ];
  }

  createCalibrationOtherPage(imgData: string[]) {
    console.log(imgData);

    const pageContent = [];

    // Sayfa başına bir görsel ekliyoruz ve her sayfada bir kırılma ekliyoruz.
    for (let i = 0; i < imgData.length; i++) {
      pageContent.push({
        image: imgData[i],
        alignment: 'center',
        fit: [850, 850],
        margin: [0, 40, 0, 0], // Görsel ile header arasına boşluk bırakabiliriz
        absolutePosition: { x: 40, y: 100 }, // Y konumunu her sayfa için ayarlayabilirsiniz
        pageBreak: i < imgData.length - 1 ? 'after' : undefined // Son görselden sonra sayfa kırılması ekliyoruz
      });
    }

    console.log(pageContent);
    return pageContent;
  }

  // Header content function
  getHeaderContent(currentPage, akraditasyonFirma, headerData: headerBilgileri,) {
    return {
      stack: [
        {
          columns: [
            this.getLeftColumn(headerData),
            this.getCenterColumn(headerData), // Pass headerData here
            this.getRightColumn(akraditasyonFirma, headerData.akraditationNo, headerData.certificateNo, headerData.certificateTarih, currentPage),
          ],
          margin: [40, 20, 20, 10],
        },
        { canvas: [{ type: 'line', x1: 30, y1: 0, x2: 545, y2: 0, lineWidth: 1 }] },
      ],
    };
  }

  // Left column content
  getLeftColumn(headerData) {
    return {
      width: '25%',
      stack: headerData.firmaLogo ? [
        { image: headerData.firmaLogo, fit: [75, 75] }
      ] : [
        { text: "", fontSize: 10, italics: true }
      ],
      alignment: 'left',
    };
  }

  // Center column content
  getCenterColumn(headerData) {
    return {
      width: '50%',
      stack: [
        { text: `${headerData.firmaAdi}`, bold: true, fontSize: 14 },
        { text: `${headerData.firmaAdresi}`, fontSize: 10 },

        { text: "KALİBRASYON SERTİFİKASI", bold: true, fontSize: 14, margin: [0, 10, 0, 0] },
        { text: "Calibration Certificate", fontSize: 10 },
      ],
      alignment: 'center',
    };
  }

  // Right column content
  getRightColumn(akraditasyonFirma, akraditationNo, certificateNo, certificateTarih, currentPage) {
    return {
      width: '25%',
      stack: [
        currentPage === 1 ?
          { image: akraditasyonFirma, fit: [75, 75], alignment: 'center' } :
          { text: '' },
        {
          table: {
            widths: [65],
            body: [
              [{ text: akraditationNo, alignment: 'center' }],
              [{ text: certificateNo, alignment: 'center' }],
              [{ text: certificateTarih, alignment: 'center' }],
            ],
          },
          marginTop: 2,
          marginLeft: 30,
        }
      ],
      alignment: 'right',
    };
  }

  // Footer content function
  getFooterContent(currentPage, pageCount) {
    let firstPageFooterDescriptionToHtml = htmlToPdfmake(this.firstPageFooterDescription);
    console.log(firstPageFooterDescriptionToHtml);
    firstPageFooterDescriptionToHtml = this.applyDefaultFontSize(firstPageFooterDescriptionToHtml);
    // İlk sayfa için footer içeriğini ayarlarken margin ve padding ekliyoruz.
    return {
      stack: [
        // Footer'da bir çizgi ekliyoruz
        {
          canvas: [{ type: 'line', x1: 30, y1: 0, x2: 550, y2: 0, lineWidth: 1 }],
        },
        currentPage === 1 ? {
          stack: [
            firstPageFooterDescriptionToHtml
          ],
          margin: [30, 0, 30, 0], // Alt margin'ini biraz daha azaltarak daha fazla alan bırakıyoruz
          fontSize: 8, // Font boyutunu küçültüyoruz
        } : { text: '' },
        // Sayfa numarasının olduğu kısım
        {
          text: `Sayfa No: ${currentPage} / ${pageCount}`,
          fontSize: 8,
          alignment: 'center',
          margin: [0, 5], // Sayfa numarasının alt kısmına margin ekliyoruz
        },

        // İngilizce sayfa numarası kısmı
        {
          text: `Page No: ${currentPage} / ${pageCount}`,
          fontSize: 6,
          alignment: 'center',
          margin: [0, 5], // Margin artırarak metnin alt kısmı daha fazla yer kaplasın
        },
      ],
      margin: [0, currentPage === 1 ? 0 : 50, 0, 0]
    };
  }
}


export class headerBilgileri {
  firmaLogo: string;
  firmaAdi: string;
  firmaAdresi: string;
  akraditationFirma: number;
  akraditationNo: string;
  certificateNo: string;
  certificateTarih: string;
}

export interface CalibrationData {
  deviceOwner: string;
  address: string;
  orderNumber: string;
  deviceName: string;
  manufacturer: string;
  modelType: string;
  serialNumber: string;
  calibrationDate: string;
  certificatePageNumber?: number;
  onaylayan: string;
  kalYapan: string;
  certificateNo: string;
}

export interface CalibrationPage2 {
  measurementUncertainty: string; // Ölçüm Belirsizliği
  calibrationMethod: string; // Kalibrasyon Yöntemi
  references: Reference[]; // Referanslar
  device: Device;
  remarks: string; // Açıklamalar
}

export interface Device {
  deviceName: string;
  serialNo: string;
  deviceNumber: string;
  location: string;
  brand: string;
  type: string;
  range: string;
  resolution: string;
  incomingDateOfDeviceLaboratory: string;
  visualFunctionInspectionDevice: string;
}

export interface Reference {
  deviceName: string;
  brand: string;
  model: string;
  serialNumber: string;
  certificateNumber: string;
  calibrationDate: string;
  tracebility: string;
}
